import merge from 'lodash/merge';

import { suppressLoadingOnRefetch } from '../../../../../../../common/util/suppressLoadingOnRefetch';
import {
  IndicationActivity_OrderBookSalesStateForSalesTraderQueryVariables,
  useIndicationActivity_OrderBookSalesStateChangedForSalesTraderSubscription,
  useIndicationActivity_OrderBookSalesStateForSalesTraderQuery,
} from './__generated__';

export const useIndicationActivityOrderBookSalesStateForSalesTraderQuery = (
  variables: IndicationActivity_OrderBookSalesStateForSalesTraderQueryVariables,
  cmgEntityKey: string | undefined,
  canReadOfferingAndIndication: boolean = false
) => {
  const skip = !cmgEntityKey || !variables.offeringId || !canReadOfferingAndIndication;

  const queryResult = useIndicationActivity_OrderBookSalesStateForSalesTraderQuery({
    variables,
    fetchPolicy: 'cache-and-network',
    skip,
    notifyOnNetworkStatusChange: true,
  });

  const { loading, networkStatus, updateQuery } = queryResult;

  useIndicationActivity_OrderBookSalesStateChangedForSalesTraderSubscription({
    variables,
    skip,
    ignoreResults: true,
    onData: ({ data: subscriptionData }) => {
      const update = subscriptionData.data?.orderBookSalesStateChangedForSalesTrader;

      if (!update) return;

      updateQuery(prev =>
        merge({}, prev, {
          salesAndTradingOrderBook: {
            salesState: update.salesState,
          },
        })
      );
    },
  });

  return { ...queryResult, loading: suppressLoadingOnRefetch(loading, networkStatus) };
};
